export const toggleForm = (toggle) => {

    return function(dispatch) {

        dispatch({
            type: "TOGGLE_FORM",
            payload: !toggle
        })
    }

}


// WEBPACK FOOTER //
// ./src/actionCreators/toggleForm.js